import { getCurrentInstance } from 'vue'

// eslint-disable-next-line
export default function useGlobal() {
  const instance = getCurrentInstance()
  if (!instance) return
  return instance.appContext.config.globalProperties
}
